import styled from 'styled-components';

import { MEDIA_QUERIES } from '@student-coin/coinpaper-components';

export const Container = styled.div`
  padding: 1rem 0;
  border: 1px dashed #000000;
  border-left: none;
  border-right: none;
  display: flex;
  @media ${MEDIA_QUERIES.tablet} {
    padding: 2rem 0;
  }
`;

export const AvatarContainer = styled.div`
  position: relative;
  border-radius: 50%;
  overflow: hidden;
  height: 5rem;
  width: 5rem;
  @media ${MEDIA_QUERIES.tablet} {
    height: 7.1875rem;
    width: 7.1875rem;
  }
`;

export const DescriptionWrapper = styled.div`
  margin-left: 1rem;
  flex: 1;
  align-self: center;
  @media ${MEDIA_QUERIES.tablet} {
    margin-left: 1.5rem;
  }
`;

export const Name = styled.p`
  color: ${({ theme }) => theme.colors.title};
  font-family: ${({ theme }) => theme.typography.paragraph.fontFamily.quote};
  font-weight: ${({ theme }) => theme.typography.paragraph.fontWeight.xLarge};
  font-size: ${({ theme }) => theme.typography.paragraph.fontSize.quote.mobile};
  line-height: 21.6px;
  margin-bottom: 0.5rem;
  @media ${MEDIA_QUERIES.tablet} {
    font-size: 1.5rem;
    line-height: 2.025rem;
  }
`;

export const Description = styled.p`
  color: #474747;
  font-family: ${({ theme }) => theme.typography.paragraph.fontFamily.default};
  font-weight: ${({ theme }) => theme.typography.paragraph.fontWeight.large};
  font-size: ${({ theme }) => theme.typography.paragraph.fontSize.medium.mobile};
  line-height: 1.1625rem;
  @media ${MEDIA_QUERIES.tablet} {
    font-size: ${({ theme }) => theme.typography.paragraph.fontSize.large.pc};
    line-height: 1.6rem;
  }
`;
